import {BaseFilter} from "./base.filter";

export class JobFilter extends BaseFilter {
  status: JobStatus;
  createdById: string;
  isQuotation: boolean;

  constructor() {
    super();

    this.isQuotation = false;
  }
}

export enum JobStatus {
  Quotation,
  Complete,
  AwaitingDelivery,
  AwaitingShipping,
  AwaitingCollection,
  AwaitingPayment,
  AwaitingInformation,
  Loading,
  Shipping,
  Booked
}
